import { collection, doc, getDocs, setDoc, updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";
import { format, startOfMonth, endOfMonth, eachDayOfInterval, startOfWeek, endOfWeek, addDays, isSunday } from 'date-fns';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Pencil } from "react-bootstrap-icons";
import { DndProvider } from "react-dnd";
import DropArea from "./formArea";
import { HTML5Backend } from "react-dnd-html5-backend";
import DutieField from "./dutiesField";
import DropAreaDuties from "./dutiesArea";

const SetDuties = () => {
    const navigate = useNavigate();
    const { currentMonth } = useParams();
    const { groupId } = useParams();

    const [data, setData] = useState([]);
    const [activeTeam, setActiveTeam] = useState([]);
    const [allSundays, setAllSundays] = useState([]);
    const [allDuties, setAllDuties] = useState([]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "Serving/c9U8iHoqB4kgCfBaF0Fr/Teams"));
                const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                setData(documents);
                setActiveTeam(documents[0]);

                const querySnapshot2 = await getDocs(collection(db, `Serving/c9U8iHoqB4kgCfBaF0Fr/Teams/${documents[0].id}/${format(currentMonth,"MMMMyyyy")}`));
                const documents2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                for (let i = 0; i < documents2.length; i++) {
                    if (documents2[i].id === 'Available') {
                        documents2.splice(i, 1);
                    }
                }

                setAllDuties(documents2);
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };

        function getSundaysOfCurrentMonth() {
            const today = new Date();
            const start = startOfMonth(today);
            const end = endOfMonth(today);
        
            const days = eachDayOfInterval({ start, end });
        
            const sundays = days.filter((day) => isSunday(day));
        
            setAllSundays(sundays);
        }
    
        getSundaysOfCurrentMonth()
        fetchData();
    }, []);

    const [avails, setAvails] = useState([]);
    const [availsDate, setAvailsDate] = useState([]);

    const seeAvails = async (e) => {
        const availDate = e.target.parentNode.childNodes[0].innerHTML;

        const querySnapshot = await getDocs(collection(db, `Serving/c9U8iHoqB4kgCfBaF0Fr/Teams/${groupId}/${currentMonth}`));
        const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        for (let i = 0; i < documents.length; i++) {
            if (documents[i].id === "Available") {
                const { id, ...newData } = documents[i];
                setAvails(newData);
            }
        }
        
        document.getElementById("avails-tab").style.display = "block";
    }

    const [formFields, setFormFields] = useState([]);
    const addField = (fieldInput, group, date) => {
        const newField = {
          id: Date.now(), 
          name: fieldInput.Name,
          surname: fieldInput.Surname,
          image: fieldInput.ProfileImage,
          duty: group,
          date: date
        };

        setFormFields((prevFields) => [...prevFields, newField]);
    };

    const saveDuties = async (e) => {
        e.target.innerHTML = "Saving...";
        for (const key in formFields) {
            if (formFields.hasOwnProperty(key)) { 
                await updateDoc(doc(db, `Serving/c9U8iHoqB4kgCfBaF0Fr/Teams/${groupId}/${currentMonth}`, `${formFields[key].date}`), {
                    [formFields[key].duty]: [formFields[key].id,formFields[key].name,formFields[key].surname,formFields[key].image], 
                });
            }
        }

        navigate("/serving");
    };

    return (
        <div id="content">
            <DndProvider backend={HTML5Backend}>
                <div className='row'>
                    <div className="col-sm-6">
                        <h1>Duties: {activeTeam.Name}</h1>
                        <h2 className='ev-sub-title'>{currentMonth}</h2>
                    </div>
                    <div className="col-sm-6" style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                        <button onClick={(e) => saveDuties(e)}>Save Duties</button>
                    </div>
                </div>
                <br/>
                <div id="avails-tab">
                    <h5>Available for {availsDate}</h5>
                    <hr/>
                    <div className='row'>
                        {Object.keys(avails).map(( key, index ) => {
                            return <div className="col"><DutieField fieldInput={avails[key]} /></div>
                        })}
                    </div>
                </div>
                <div className='row'>
                    {allDuties.map(duty => {
                        return (
                            duty.id.includes("AM") ? (
                            <div className="col" style={{borderLeft: "1px solid #e7e7e7", borderRight: "1px solid #e7e7e7"}}>
                                <div><h6 style={{fontSize: "22px"}}>{duty.id}</h6> <Pencil width="20px" height="20px" onClick={(e) => seeAvails(e)}/></div>
                                {Object.keys(duty).map(( key, index ) => {
                                    return (<div id={key}>
                                        <p className="duty-title">{key}</p>
                                        <p> <img src={duty[key][3]} style={{width: "25px", borderRadius: "500px"}}/> {duty[key][1]} {duty[key][2]}</p>
                                        {formFields.map((field, index) => {
                                            return field.duty === key && field.date === duty.id ? (
                                                <div style={{ display: "flex", alignItems: "center"}} id={duty.id} key={index}>
                                                <img src={field.image} style={{width: "25px", borderRadius: "500px"}}/>
                                                <p style={{marginBottom: "0px", marginLeft: "10px"}}>{field.name} {field.surname}</p>
                                                </div>
                                            ) : null;
                                        })} 
                                        <DropAreaDuties date={duty.id} 
                                        group={key} 
                                        addField={addField} />
                                    </div>)
                                })}
                            </div>
                            ) : null
                        );
                    })}
                </div>
                <br/>
                <br/>
                <div className='row'>
                    {allDuties.map(duty => {
                        return (
                            duty.id.includes("PM") ? (
                            <div className="col" style={{borderLeft: "1px solid #e7e7e7", borderRight: "1px solid #e7e7e7"}}>
                                <div><h6 style={{fontSize: "22px"}}>{duty.id}</h6> <Pencil width="20px" height="20px" onClick={(e) => seeAvails(e)}/></div>
                                {Object.keys(duty).map(( key, index ) => {
                                    return (<div id={key}>
                                        <p className="duty-title">{key}</p>
                                        <p> <img src={duty[key][3]} style={{width: "25px", borderRadius: "500px"}}/> {duty[key]}</p>
                                        {formFields.map((field, index) => {
                                            return field.duty === key && field.date === duty.id ? (
                                                <div style={{ display: "flex", alignItems: "center"}} id={duty.id} key={index}>
                                                <img src={field.image} style={{width: "25px", borderRadius: "500px"}}/>
                                                <p style={{marginBottom: "0px", marginLeft: "10px"}}>{field.name} {field.surname}</p>
                                                </div>
                                            ) : null;
                                        })} 
                                        <DropAreaDuties date={duty.id} 
                                        group={key} 
                                        addField={addField} />
                                    </div>)
                                })}
                            </div>
                            ) : null
                        );
                    })}
                </div>
            </DndProvider>
        </div>
    )
}

export default SetDuties; 